import React from 'react';
import { X } from 'lucide-react';
import Base from './Base';

type TwoColumnModalProps = {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
};

/**
 * TwoColumnModal is a modal component that displays its children in a two-column layout.
 * You need to pass 2 children to the component, and it will render them side by side.
 */
export const TwoColumnModal = (props: TwoColumnModalProps) => {
  const { children, open, onClose } = props;

  return (
    <Base isOpen={open} onRequestClose={onClose} size="L">
      <div className="relative">
        <div
          className="absolute right-xxl top-xxl mobile:right-l mobile:top-l"
          role="button"
          onClick={onClose}
          onKeyDown={onClose}
        >
          <X className="size-m" />
        </div>
        <div className="grid grid-cols-2 tablet-max:grid-cols-1">
          {children}
        </div>
      </div>
    </Base>
  );
};

export default TwoColumnModal;
